import ArticleCard from '@/components/feature/ArticleCard';
import type { Article } from '@/types/content';

export default function RelatedArticles({ articles }: { articles: Article[] }) {
  if (articles.length === 0) return null;

  return (
    <section className="bg-background-100 py-14 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="flex items-center gap-3">
          <span className="h-px w-8 bg-primary-400" />
          <h3 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">继续深扒</h3>
        </div>
        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {articles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}